/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import QuotationUpload from "../QuotationUpload/QuotationUpload";

class UploadTemplate extends Component {
  state = {
    docDetails: null,
    // docName: null
  };

  _uploadDocument = () => {
    const { templateName, docDetails } = this.state;
    if (templateName !== null || templateName !== "") {
      return (
        <QuotationUpload
          uploaded={docDetails !== null}
          setDoc={this.props.setDoc}
          resetFileDetails={this._resetFileDetails}
        />
      );
    }
    return null;
  };

  _resetFileDetails = () => {
    this.setState({
      docDetails: null,
      // docName: null,
      //  errMsg: ""
    });
  };

  render() {
    return (
      <div className="createdoc-upload-wrapper choose-template-wrapper">
        <div className="go-backto-tem-selection-row">
          <div
            id="get-back-to-templates"
            className="get-back-to-templates"
            data-test="createtemplatepopup-get-back-to-templates-button"
            onClick={() => this.props.setView(true)}>
            <span>
              <FontAwesomeIcon icon={["far", "arrow-left"]} />
            </span>
            &nbsp; Get back to templates
          </div>
          <div
            id="create-blank-document"
            onClick={() => this.props.submitData()}
            data-test="createtemplatepopup-create-blank-template-button"
            className="get-back-to-templates">
            Create blank template
          </div>
        </div>
        <div className="assetcreatedoc-popup-body">
          <div className="select-template-list-wrapper">
            {this._uploadDocument()}
          </div>
        </div>
      </div>
    );
  }
}

export default UploadTemplate;



// WEBPACK FOOTER //
// ./src/components/CreateTemplatePopup/UploadTemplate.js